document.addEventListener("DOMContentLoaded", function () {
  initProductSliders();
});

function initProductSliders() {
  const productSliderSections = document.querySelectorAll(".section-slider-product");

  productSliderSections.forEach(function (section) {
    const thumbsSlider = section.querySelector(".content-list-slider");
    const cardSlider = section.querySelector(".content-card-product");

    if (!thumbsSlider || !cardSlider) return;

    const wrapper = cardSlider.querySelector(".swiper-wrapper");
    const thumbsWrapper = thumbsSlider.querySelector(".swiper-wrapper");

    if (!wrapper || !thumbsWrapper) return;

    let slides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
    const thumbSlides = Array.from(thumbsWrapper.querySelectorAll(".swiper-slide"));
    const slideCount = slides.length;

    if (slideCount <= 3) {
      const clonesNeeded = 3;
      for (let i = 0; i < clonesNeeded; i++) {
        slides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          if (clone instanceof HTMLElement) {
            clone.classList.add("slide-clone");
          }
          wrapper.appendChild(clone);
        });
        thumbSlides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          if (clone instanceof HTMLElement) {
            clone.classList.add("slide-clone");
          }
          thumbsWrapper.appendChild(clone);
        });
      }
      slides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
    }

    let swiperTumb = new Swiper(thumbsSlider, {
      spaceBetween: 12,
      slidesPerView: 1,
      watchSlidesProgress: true,
      allowTouchMove: false,
      simulateTouch: false,
      preventClicks: true,
      preventClicksPropagation: true,
      loop: true,
    });

    let swiperCard = new Swiper(cardSlider, {
      slidesPerView: "auto",
      centeredSlides: true,
      loop: true,
      loopedSlides: slides.length,
      spaceBetween: 12,
      navigation: {
        nextEl: section.querySelector(".swiper-button-next"),
        prevEl: section.querySelector(".swiper-button-prev"),
      },
      thumbs: {
        swiper: swiperTumb,
      },
      breakpoints: {
        768: {
          slidesPerView: "auto",
          centeredSlides: true,
          spaceBetween: 12,
        },
      },
      on: {
        slideChangeTransitionEnd: function () {
          const realIndex = this.realIndex;
          const allSlides = this.slides;
          const totalSlides = allSlides.length;

          const prevIndex = (realIndex - 1 + totalSlides) % totalSlides;
          const nextIndex = (realIndex + 1) % totalSlides;

          allSlides.forEach((slide, index) => {
            slide.classList.remove("left-neighbor", "right-neighbor");
            if (index === prevIndex) slide.classList.add("left-neighbor");
            if (index === nextIndex) slide.classList.add("right-neighbor");
          });
        },
      },
    });
  });
}
